/* ============================================================================
   M1 — PTL Courier Partner Setup (placeholder)   Route: /supply/ptl
   v6 renderPtlPlaceholder (mockup /ptl/supply) — PTL freight supply-side setup
   ships as its own dedicated module; the as-is PTL flow continues meanwhile.
   Static informational card only. Frontend-only, no data, no API calls.
   ========= */
import React from 'react'
import BoltIcon from '@mui/icons-material/Bolt'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import PageTitle from '../../../components/PageTitle'
import {PageHeader} from '../components'

export default function PtlPlaceholder() {
  return (
    <>
      <PageTitle>PTL Courier Partner Setup — ProShip</PageTitle>
      <PageHeader
        title='PTL Courier Partner Setup'
        sub='Less-than-truckload (PTL) freight — courier-partner supply-side setup.'
      />

      <div className='card card-pad' style={{maxWidth: 780}}>
        <span className='banner'>
          <BoltIcon style={{width: 13, height: 13}} />
          Separate module — on the roadmap
        </span>

        {/* .lead styling is scoped to .scaffold in the stylesheet, so mirror it inline */}
        <p
          className='lead'
          style={{
            marginTop: 12,
            marginBottom: 16,
            fontSize: 14,
            color: 'var(--ink-2)',
            maxWidth: 760,
            lineHeight: 1.6,
          }}
        >
          PTL courier-partner setup will ship as its <b>own dedicated module</b>, mirroring this
          D2C experience (partner dashboard, directory, onboarding, agreements, commercials and
          reconciliation). PTL is intentionally <b>not</b> part of the D2C build.
        </p>

        <div className='warnbox info' style={{marginTop: 4}}>
          <InfoOutlinedIcon />
          <div>
            Until the dedicated module ships, the{' '}
            <b>current as-is PTL flow continues to work exactly as today</b> — no change to
            existing PTL courier configuration or operations.
          </div>
        </div>

        <div className='seclabel' style={{margin: '18px 0 8px'}}>What the PTL module will add</div>
        <ul
          style={{
            margin: 0,
            paddingLeft: 18,
            color: 'var(--neutral)',
            fontSize: 13,
            lineHeight: 1.9,
          }}
        >
          <li>PTL partner directory &amp; PTL-specific onboarding (pickup type, lane/route, appointment delivery)</li>
          <li>PTL rate cards (per-kg slabs, FTL/PTL lanes, ODA &amp; appointment charges)</li>
          <li>PTL agreements, invoice &amp; freight reconciliation</li>
        </ul>
      </div>
    </>
  )
}
